import { atom } from "jotai";
import { selectAtom } from "jotai/utils";
import type { Search } from "../../interfaces/Search";

export const initialSearchModuleState = {
  visible: false,
  searchText: "",
};

export const SearchStore = atom<Search.Input>(initialSearchModuleState);

export const SearchInputStoreMutate = atom(null, (get, set, action: Search.Input) => {
  const current = get(SearchStore);
  set(SearchStore, { ...initialSearchModuleState, ...current, ...action });
});

export const SearchSelectIsVisible = selectAtom<Search.Input, boolean>(SearchStore, ({ visible }) => visible);
